import React, { useState } from "react";
import Header from "../components/Header";
import { useAuth } from "../context/AuthContext";
import { useFeed } from "../context/FeedContext";
import { pageColors } from "../mock";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const NewsCenter = () => {
  const navigate = useNavigate();
  const { current } = useAuth();
  const { news, postNews } = useFeed();
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [link, setLink] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  React.useEffect(() => { document.title = "TMM|NEWS CENTER"; }, []);

  const post = async (e) => {
    e.preventDefault();
    setErr("");
    if (!title.trim()) {
      setErr("Give it a headline first.");
      return;
    }
    setBusy(true);
    const r = await postNews({ title, body, link });
    setBusy(false);
    if (!r.ok) {
      setErr(r.error);
      return;
    }
    setTitle(""); setBody(""); setLink("");
  };

  return (
    <>
      <Header hoverColor={pageColors.contact} compact={false} />
      <div className="feed-page">
        <button
          type="button"
          className="feed-back"
          onClick={() => navigate("/members")}
        >
          <ArrowLeft size={16} /> Back to Members
        </button>

        <header className="feed-hero">
          <h1 className="feed-title">NEWS CENTER</h1>
          <p className="feed-sub">Community events, project drops, highlights worth reading.</p>
        </header>

        {current && current.is_admin && (
          <form className="feed-composer" onSubmit={post}>
            <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Headline…" />
            <textarea rows={4} value={body} onChange={(e) => setBody(e.target.value)} placeholder="Short write-up…" />
            <input value={link} onChange={(e) => setLink(e.target.value)} placeholder="Optional link (https://…)" />
            {err && <div className="auth-error">{err}</div>}
            <button type="submit" className="btn-solid" disabled={busy}>
              {busy ? "…" : "Publish news item"}
            </button>
          </form>
        )}
        {current && !current.is_admin && (
          <div className="news-note">
            News Center is curated — only editors can publish here.
          </div>
        )}

        <div className="feed-list">
          {news.length === 0 && <div className="feed-empty">No news items yet.</div>}
          {news.map((n) => (
            <article key={n.id} className="feed-item">
              <div className="feed-item-body" style={{ padding: "0.4rem 0" }}>
                <div className="feed-item-meta">
                  <span className="feed-item-author">{n.authorName}</span>
                  <span className="feed-item-ts">{new Date(n.ts).toLocaleString()}</span>
                </div>
                {n.title && <h3 className="feed-item-title">{n.title}</h3>}
                {n.body && <p className="feed-item-text">{n.body}</p>}
                {n.link && (
                  <a href={n.link} target="_blank" rel="noopener noreferrer" className="btn-ghost" style={{ marginTop: 8 }}>
                    Open link
                  </a>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </>
  );
};

export default NewsCenter;
